import { IconName } from '@wui/common-library'

import { getNumberFromString } from '@/shared/utils/string'

const conferenceIcons: Array<IconName> = [
  'car',
  'city',
  'clock',
  'coffee',
  'computer',
  'flower',
  'koala',
  'koalaBig',
  'koalaOutlined',
  'lightbulb',
  'logoBare',
  'palette',
  'paw',
  'plant',
  'rabbit',
  'sportsSoccer',
  'work',
]

export const useConferenceIcon = () => {
  const getConferenceIcon = (confName: string): IconName => {
    const x = getNumberFromString(confName)
    return conferenceIcons[x % conferenceIcons.length] ?? 'car'
  }

  return {
    getConferenceIcon,
  }
}
